import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * Get status
 * @param {boolean} confirmed
 * @returns {JSX.Element}
 */
const CourseListItemStatus = ({ status }) => {
	return (
		<div
			className={`upcoming-event-list__item__status upcoming-event-list__item__status--${status[0]?.slug}`}
		>
			{decodeEntities(status[0]?.name)}
		</div>
	);
};

export default CourseListItemStatus;
